// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"edbb4fb7","387":"a5ebb450","810":"38a33ac6","834":"7483622b"}[chunkId] + ".chunk.css";
};